const CARTES_BANCAIRES_VALIDATION_BIN_LENGTH = 8;

module.exports = {
  CARTES_BANCAIRES_VALIDATION_BIN_LENGTH,
};
